export const MAPBOX_DEV_TOKEN = 'pk.eyJ1IjoibWlwcm8tZGV2IiwiYSI6ImNrOXdrOXY3bDA5cXgzaGtvZmk4bWdtYTcifQ.2gslFdcDX-zA9Q5mRBknrQ';
export const MAPBOX_PROD_TOKEN = 'pk.eyJ1IjoibWlwcm8tZGV2IiwiYSI6ImNrOXdrYWx3ZTA2ZmczbHB4MmQ3N2I1a2UifQ.5Ou9Q2hJMD7EZWLvoUuqKA';
